var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error.visible)?_c('Alert',{attrs:{"type":"error"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.error.title))]},proxy:true}],null,false,3749315302)},[_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.error.message))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }